'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _track = require('./utils/track');

var _track2 = _interopRequireDefault(_track);

var _events = require('./events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackBarrierSubscribe() {
    return (0, _track2.default)(_events.EVENT_BARRIER_SUBSCRIBE);
}

exports.default = trackBarrierSubscribe;


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/~/rp-analytics/lib/trackBarrierSubscribe.js
// module id = 1628
// module chunks = 1